import React, { useEffect } from 'react';
import './Testimonials.css';

const testimonialsData = [
  {
    id: 1,
    name: "Sunil D Bisht",
    location: "Zirakpur, India",
    content: "Today I received my replacement of Allen Cooper Safety Shoes. Though Shoe Shiner missing in the received box but it doesn't bother. Delivered product is looking good hope quality & comfort will not disappoint me. I am highly satisfied with the service commitment & customer satisfaction of team Industrybull. Thank you very much for the replacement.",
  },
  {
    id: 2,
    name: "Mohammed Abdul Faheem",
    location: "Telangana",
    content: "Have a nice day. Thanks, today I received my order. Thanks for your help and continuous support.",
  },
  {
    id: 3,
    name: "Ramamurthy Janga",
    location: "Chennai",
    content: "Many Thanks to Industrybull Team for round the clock immediate Responses, being the 1st Order. Many will follow soon. Eagerly awaiting for the 4 Items to be Gifted to my Daughter on her Birthday this week. Please Convey my Warm Regards to Top Management for having an Excellent Dedicated Team.",
  },
  {
    id: 4,
    name: "Sreeji Ts",
    location: "Kollam, Kerela",
    content: "I am overjoyed and overwhelmed by its quality and standard. Besides, I am also very much pleased by your finest packaging. It's Mind blowing !! What a professional attitude guys!! I have never seen such a high quality packaging since last 13 years, the time I began my e purchase. Hats off to you friends. You have earned a contended and permanent customer in shape of me. I profusely thank you. My best wishes. Keep up the good work.",
  },
  {
    id: 5,
    name: "Merajuddin Khan",
    location: "Lucknow",
    content: "I’m really Impressed by Industrybull. Surprising.. I m very very much satisfied with Industrybull care. I like it.",
  },
  {
    id: 6,
    name: "Maunang Contractor",
    location: "Ahmedabad",
    content: "\"I am very happy with your service. I received my replaced order without any problem and would like to say that wonderful service provided by INDUSTRYBULL..\"",
  },
  {
    id: 7,
    name: "Balaji Narsimhan",
    location: "Krishnagiri",
    content: (
      <>
        <p>Here is my feedback regarding product and service:</p>
        <p>“I received my replaced order without any problem and would like to say that wonderful service provided by INDUSTRYBULL..„</p>
        <ul className="testimonial-card__list">
          <li>Packaging and shipping - Great 5 stars</li>
          <li>Product Price - Good, Value for the money</li>
          <li>Product quality - Good</li>
          <li>Quality testing by Industrybull—Good ...</li>
        </ul>
        <p>Overall rating 4 stars have a great day. Hope this helps in the development of your service provided in the future!</p>
      </>
    ),
  },
  {
    id: 8,
    name: "Prabir Kumar Mondal",
    location: "Kolkata",
    content: "\"Here is my feedback regarding product and service: Thanks a lot. I am in receipt of my entire order. I appreciate your effort to resolve my issue so effectively. Hope to make next deal with you in near future.\"",
  },
  {
    id: 9,
    name: "Trilochan Singh",
    location: "Mohali",
    content: "Very thank you, I appreciate your response and process. I got the refund. Thanx a lot for your service. Will always buy from you.",
  }
];

const Testimonials: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="testimonials-page">
      <div className="testimonials-container">
        
        <div className="testimonials-header">
          <h1 className="testimonials-title">Customer <span>Testimonials</span></h1>
          <p className="testimonials-subtitle">
            See what our valued customers have to say about their experience with Industrybull.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonialsData.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-card__quote-icon">"</div>
              
              <div className="testimonial-card__content">
                {testimonial.content}
              </div>
              
              <div className="testimonial-card__author">
                <div className="testimonial-card__avatar">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="testimonial-card__author-info">
                  <h4 className="testimonial-card__name">{testimonial.name}</h4>
                  <p className="testimonial-card__location">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Testimonials;
